import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

// Components
import { Text } from '@beef/ui-kit';
import { Picture } from 'components';

// Styles
import styles from './styles.pcss';

const cx = classNames.bind(styles);

const Content = ({ data }) => {
  const { title, description, imageUrl } = data || {};

  return (
    <>
      {imageUrl && (
        <Picture className={cx('image')} defaultImage={imageUrl} alt="Успех" lazy />
      )}

      <div className={cx('title')}>
        <Text tagType="h2" size="size3-m">{title}</Text>
      </div>

      {description && (
        <div className={cx('description')}>
          <Text size="size5-r-l" color="grey60">{description}</Text>
        </div>
      )}

    </>
  );
};

Content.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    imageUrl: PropTypes.string,
    buttonGroup: PropTypes.array,
  }),
};

export { Content };
